<template>
  <div class="house-importer-add-device-value">
    <app-popup :active.sync="active" title="Добавлене показания">
      <div class="house-importer-add-device-value__row">
        <app-datepicker label="Месяц" v-model="body.month" format="MMMM yyyy" minimum-view="month"/>
      </div>

      <div class="house-importer-add-device-value__row">
        <app-input label="Значение" v-model="body.value" vtype="udouble"/>
      </div>

      <div class="house-importer-add-device-value__row">
        <vs-checkbox v-model="body.calculated">calculated</vs-checkbox>
      </div>

      <div class="house-importer-add-device-value__row">
        <vs-checkbox v-model="body.is_standard">is_standard</vs-checkbox>
      </div>

      <div class="house-importer-add-device-value__row house-importer-add-device-value__row_buttons">
        <app-button color="success" @click="sendValue" :disabled="isSending">{{isSending ? 'Добавляю' : 'Добавить'}}</app-button>
      </div>
    </app-popup>
  </div>
</template>

<script>
  export default {
    name: "AddNewValuePopup",
    data() {
      return {
        active: false,
        device: {},
        isSending: false,
        body: {
          value: null,
          calculated: false,
          is_standard: false,
          month: new Date()
        }
      }
    },
    methods: {
      open(device) {
        this.device = device;
        this.isSending = false;
        this.body = {
          value: null,
          calculated: false,
          is_standard: false,
          month: new Date()
        };
        this.active = true;
      },
      async sendValue(){
        this.isSending = true;
        try{
          let body = {
            device_id: this.device.id,
            date_value: this.$options.filters.moment(this.body.month, 'YYYY-MM'),
            value: this.body.value,
            calculated: this.body.calculated,
            is_standard: this.body.is_standard,
          };
          let {data} = await this.$http.post('import/houses/device_value', body);
          this.$emit('add', {device: this.device, value: data});
          this.active = false;
          this.isSending = false;
          this.$vs.notify({color: 'success', title: 'Успешное добавление', text: 'Показание добавлено'});
        }
        catch(e){
          this.isSending = false;
          this.$vs.notify({color: 'danger', title: 'ERROR', text: e.message});
        }


      }
    }
  }
</script>

<style lang="scss">
.house-importer-add-device-value{
  &__row{
    margin-bottom: 15px;

    &_buttons{
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
}
</style>